export default __webpack_public_path__ + "static/media/main-logo.4ae99ecb.svg";